import { render, staticRenderFns } from "./seminar.vue?vue&type=template&id=8228a854&scoped=true&"
import script from "./seminar.vue?vue&type=script&lang=js&"
export * from "./seminar.vue?vue&type=script&lang=js&"
import style0 from "./seminar.vue?vue&type=style&index=0&id=8228a854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8228a854",
  null
  
)

export default component.exports